import React, { useContext } from 'react'
import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { apiContext } from 'services/ApiContext'

import './style.scss'

const PortfolioButton = () => {
  const { projects, user } = useContext(apiContext)
  const { push } = useHistory()

  if (
    (!projects || projects.length < 2) &&
    (!user || !user.group || user.group.organizationType === 'STARTUP')
  )
    return null

  return (
    <Button className="mr-3 ant-btn-primary" onClick={() => push('/portfolio')}>
      <FormattedMessage id="topBar.menu.portfolio" />
      <span className="icmn-briefcase portfolio-btn-text" />
    </Button>
  )
}

export default PortfolioButton
